export default __webpack_public_path__ + "static/media/3e.3ee2a2a4.png";